import { Carousel as JLDSCarousel } from "@JohnLewisPartnership/jl-design-system/dist/components/carousel/Carousel";
import { ProductCard } from "../ProductCard";
import { ProductListLayoutProps } from "../../types/types";

export const Carousel = ({
  config,
  products,
  heading,
}: ProductListLayoutProps) => {
  return (
    <JLDSCarousel
      id="carousel"
      ariaLabel="carousel"
      heading={heading?.main}
      subheading={heading?.subHeading}
    >
      {products.map((product, ind) => (
        <ProductCard
          key={
            product.advertising
              ? `${product.aliases.pimProductId}-sponsored`
              : product.aliases.pimProductId
          }
          product={product}
          config={config}
          index={ind}
        />
      ))}
    </JLDSCarousel>
  );
};
